import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const ALL_TIME_SLOTS = ["10:00 AM","11:00 AM","12:00 PM","1:00 PM","2:00 PM","3:00 PM","4:00 PM","5:00 PM","6:00 PM","7:00 PM","8:00 PM","9:00 PM"];

export function ScheduleEditor({ schedule, onUpdateDay, onSave, saving }) {
  return (
    <div className="space-y-6">
      <h2 className="font-heading text-2xl text-healing-burgundy">My Working Schedule</h2>
      <p className="text-sm text-healing-burgundy-light">Set which days you work and your available hours. Clients will only see time slots during your working hours.</p>

      <div className="admin-card space-y-4">
        <div className="grid gap-4">
          {schedule.map((day) => (
            <div 
              key={day.day} 
              className={`flex flex-col sm:flex-row sm:items-center gap-3 p-4 rounded-xl border transition-colors ${
                day.enabled ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200'
              }`}
              data-testid={`schedule-day-${day.day}`}
            >
              <div className="flex items-center gap-3 sm:w-40">
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={day.enabled}
                    onChange={(e) => onUpdateDay(day.day, 'enabled', e.target.checked)}
                    className="sr-only peer"
                    data-testid={`schedule-toggle-${day.day}`}
                  />
                  <div className="w-10 h-5 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-healing-purple"></div>
                </label>
                <span className={`font-heading text-base capitalize ${day.enabled ? 'text-healing-burgundy' : 'text-gray-400'}`}>
                  {day.day}
                </span>
              </div>

              {day.enabled && (
                <div className="flex items-center gap-2 flex-1">
                  <Select value={day.start_time} onValueChange={(v) => onUpdateDay(day.day, 'start_time', v)}>
                    <SelectTrigger className="w-32 border-healing-border" data-testid={`schedule-start-${day.day}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {ALL_TIME_SLOTS.map(t => (
                        <SelectItem key={t} value={t}>{t}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <span className="text-healing-burgundy-light text-sm">to</span>
                  <Select value={day.end_time} onValueChange={(v) => onUpdateDay(day.day, 'end_time', v)}>
                    <SelectTrigger className="w-32 border-healing-border" data-testid={`schedule-end-${day.day}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {ALL_TIME_SLOTS.filter(t => ALL_TIME_SLOTS.indexOf(t) >= ALL_TIME_SLOTS.indexOf(day.start_time)).map(t => (
                        <SelectItem key={t} value={t}>{t}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}

              {!day.enabled && (
                <span className="text-sm text-gray-400 italic">Day off</span>
              )}
            </div>
          ))}
        </div>

        <Button
          onClick={onSave}
          disabled={saving}
          className="w-full bg-healing-purple hover:bg-healing-purple-hover text-white"
          data-testid="save-schedule-btn"
        >
          {saving ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
              Saving...
            </>
          ) : (
            <>
              <Check className="h-4 w-4 mr-2" />
              Save Schedule
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
